<template>
  <div class="row">
    <div class="col-xl-12">
      <container-headline
        class="col-xl-12"
        :headline="$t('global.wagerates')"
        :col="3"
      >
        <div class="row d-flex justify-content-between">
          <div class="ml-3">
            <button
              class="btn btn-primary"
              @click="neuerLohnansatz()"
              v-if="berechtigungen.m_finanzen.create"
            >
              <font-awesome-icon icon="fa-regular fa-plus" />{{
                $t("global.newwagerate")
              }}
            </button>
          </div>
          <div class="mr-4">
            <button
              class="btn btn-danger"
              @click="oeffneLoeschenModal"
              v-if="berechtigungen.m_finanzen.delete"
            >
              <font-awesome-icon class="mr-1" icon="fa-duotone fa-trash" />
              <span>{{ $t("global.delete") }}</span>
            </button>
          </div>
        </div>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div>
            <b-table
              ref="selectableTable"
              tbody-tr-class="item"
              :items="lohnansaetze"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :busy="isBusy"
              show-empty
              sort-icon-left
              fixed
              selectable
              select-mode="range"
              @row-dblclicked="details"
            >
              <template v-slot:head(selected)="row">
                <b-form-checkbox
                  v-model="row.selected"
                  @input="selectAllRows(row)"
                ></b-form-checkbox>
              </template>

              <template v-slot:cell(selected)="row">
                <b-form-checkbox
                  v-model="row.item.selected"
                  @input="onRowSelected(row)"
                ></b-form-checkbox>
              </template>

              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #empty>
                <div v-if="ladeFehler" class="text-center text-danger my-2">
                  <strong>{{ $t("global.errorwhileloading") }}</strong>
                </div>
                <div v-if="!ladeFehler" class="text-center text-primary my-2">
                  <strong>{{ $t("global.nodataavailable") }}</strong>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>

    <loeschen-modal
      id="lohnansatz-loeschen-modal"
      @confirmed="lohnansatzLoeschen"
      :selectedIds="selectedIds"
      :multiple="true"
    />

    <lohnansatz-modal
      ref="positionModal"
      :personID="person"
      @lohnansatz-changed="lohnansatzChanged"
      @lohnansatz-created="lohnansatzCreated"
      @abbrechen="abbrechen"
    ></lohnansatz-modal>
  </div>
</template>

<script>
import Api from "@/Api";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { BSpinner } from "bootstrap-vue";
import ContainerHeadline from "@/components/ContainerHeadline";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import LohnansatzModal from "@/components/Modals/LohnansatzModal";
import reiter from "@/mixins/Reiter";

export default {
  components: {
    ContainerHeadline,
    LoeschenModal,
    LohnansatzModal,
    BSpinner,
  },
  mixins: [reiter],
  props: {
    person: {
      type: String,
      required: false,
    },
    shown: {
      type: Boolean,
      required: false,
    },
    editable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      page: 0,
      infiniteId: +new Date(),
      anzahlProPage: 100,
      sortBy: "",
      sortDesc: false,
      isBusy: false,
      ladeFehler: false,
      lohnansaetze: [],
      lohnansatz: {},
      editLohnansatz: null,

      fields: [
        { key: "selected", label: "" },
        {
          key: "bezeichnung",
          sortable: true,
          label: this.$t("global.designation"),
        },
        { key: "ansatz", sortable: true, label: this.$t("global.rate") },
        {
          key: "lohnart.bezeichnung",
          sortable: true,
          label: this.$t("global.wagetype"),
        },
      ],
      selected: [],
      selectedIds: [],
    };
  },
  computed: {
    queryParams: function () {
      var params = {
        page: this.page,
        count: this.anzahlProPage,
      };

      if (this.suche) params.suche = this.suche;

      return params;
    },
  },
  watch: {
    shown(val) {
      if (val && this.lohnansaetze.length == 0) this.getLohnansaetze();
    },
  },
  mounted() {
    if (this.shown && this.lohnansaetze.length == 0) this.getLohnansaetze();
    this.setHeaders("global", [
      "",
      "designation",
      "rate",
      "wagetype",
    ]);
  },
  methods: {
    getLohnansaetze() {
      this.isBusy = true;

      Api.get("lohn/lohnansatz/", {
        params: {
          person: this.person,
        },
      })
        .then((response) => {
          this.lohnansaetze = response.data;
          this.ladeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.ladeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
        });
    },

    details(lohnansatz) {
      this.$bus.$emit("open-lohnansatz-modal", lohnansatz.id);
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0)
        this.$bus.$emit("openLoeschenModal", "lohnansatz-loeschen-modal");
    },

    neuerLohnansatz() {
      this.$bus.$emit("open-lohnansatz-modal");
    },

    lohnansatzChanged() {
      this.getLohnansaetze();
    },

    lohnansatzCreated() {
      this.getLohnansaetze();
    },

    abbrechen() {
      this.lohnansatz = {};
    },

    lohnansatzLoeschen() {
      Api.delete("lohn/lohnansatz/", {
        params: { ids: this.selectedIds.join(",") },
      }).then(() => {
        this.getLohnansaetze();
      });
    },

    infiniteHandler($state) {
      Api.get("lohn/lohnansatz/", {
        params: this.queryParams,
      }).then((response) => {
        console.log("final");
        if (response.data.length === this.anzahlProPage) {
          this.page += 1;
          this.lohnansaetze.push(...response.data);
          $state.loaded();
        } else {
          this.lohnansaetze.push(...response.data);
          $state.complete();
        }
      });
    },
    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = true;
          if (!this.selectedIds.includes(gp.id)) {
            this.selectedIds.push(gp.id);
          }
        });
      } else {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = false;
        });
        this.selectedIds = [];
      }
      this.$forceUpdate();
    },
    onRowSelected(row) {
      if (row.item.selected) {
        this.selectedIds.push(row.item.id);
        this.selectedIds = Array.from(new Set(this.selectedIds));
      } else {
        this.selectedIds = this.selectedIds.filter((id) => id != row.item.id);
      }
    },
  },
};
</script>
